<template>
  <div class="wtv-form">
    <div class="wtv-form-col-2">
      <div class="wtv-form-row">
        <div
          class="wtv-form-col"
          v-if="context === 'main' || context === 'main-pm'"
        >
          <Select
            type="cities"
            label="Город"
            :output="
              city && netCities.find(netCity => netCity.id === city).name
            "
            :onSelect="setCity"
            :options="netCities"
            :selected="city"
            :error="errors.officeCity"
            :required="true"
          />
        </div>
        <div
          class="wtv-form-col"
          v-if="context === 'main' || context === 'main-pm'"
        >
          <Select
            type="offices"
            label="Турагентство"
            :output="
              feedback.office &&
                netOffices().find(netOffice => netOffice.id === feedback.office)
                  ?.name
            "
            :onSelect="setOffice"
            :options="netOffices()"
            :selected="city"
            :error="errors.officeName"
          />
        </div>
        <div class="wtv-form-col">
          <Input
            label="Ваше имя"
            :value="username"
            :error="errors.username"
            :required="true"
            :onInput="() => handleInput('username')"
          />

          <Input
            label="Ваш телефон"
            :value="phone"
            :error="errors.phone"
            :required="true"
            :onInput="() => handleInput('phone')"
          />

          <Input
            label="Ваш email"
            :value="email"
            :error="errors.email"
            :onInput="() => handleInput('email')"
          />
        </div>
        <div class="wtv-form-col">
          <div class="wtv-form-control">
            <div class="wtv-form-label">Ваши пожелания</div>
            <textarea
              class="wtv-form-input wtv-form-textarea"
              @input="handleInput('adding')"
              :value="adding"
              placeholder="Например: тур на двоих с одним ребенком на 01.01 на 7 ночей"
              rows="5"
              cols="30"
            />
          </div>
          <div class="wtv-form-control">
            <div
              class="wtv-form-submit"
              :class="{ 'is-disabled': isLoading(false) }"
              @click="submitForm"
              @keyup.enter="submitForm"
            >
              {{
                isLoading(false) ? 'Обработка...' : 'Проверить наличие мест'
              }}
            </div>
          </div>
          <div>Бесплатно, банковская карта не требуется</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from '@/components/controls/Input.vue';
import Select from '@/components/controls/Select.vue';
import { useStore } from 'vuex';
import { invokeOnce/* , isValidEmail */ } from '@/functions';
import {
  computed, defineComponent, reactive, toRefs,
} from 'vue';

export default defineComponent({
  name: 'Form',
  components: {
    Input,
    Select,
  },
  setup() {
    const $store = useStore();
    const data = reactive({
      errors: {
        username: null,
        phone: null,
        email: null,
        officeCity: null,
        officeName: null,
      },
    });
    const { errors } = toRefs(data);

    const username = computed(() => $store.state.feedback.username);
    const phone = computed(() => $store.state.feedback.phone);
    const email = computed(() => $store.state.feedback.email);
    const adding = computed(() => $store.state.feedback.adding);
    const feedback = computed(() => $store.state.feedback);
    const city = computed(() => $store.state.city);
    const {
      isLoading,
      netCities,
      netOffices,
      context,
    } = $store.getters;

    const handleInput = (name) => {
      if (data.errors[name]) data.errors[name] = null;
      const { value } = window.event.target;
      invokeOnce(() => $store.commit('updateFeedback', ({ [name]: value })), 250);
    };
    const setCity = (e = window.event) => {
      $store.commit('updateCity', e.target.dataset.id);
      data.errors.officeCity = null;
      if (
        feedback.value.office
        && !netOffices().find(
          (netOffice) => netOffice.id === feedback.value.office,
        )
      ) { $store.commit('updateFeedback', ({ office: null })); }
    };

    const setOffice = (e = window.event) => {
      data.errors.officeName = null;
      const { id } = e.target.dataset;
      const newCity = netOffices().find((netOffice) => netOffice.id === id)?.city;

      if (!city.value) {
        console.log(newCity);
        $store.commit('updateCity', newCity);
      }
      $store.commit('updateFeedback', ({ office: id }));
    };

    const checkForm = () => {
      if (!username.value) {
        data.errors.username = 'Укажите, пожалуйста, ваше имя';
      } else if (username.value.length < 2) {
        data.errors.username = 'Имя должно быть не короче 2 знаков';
      }
      if (!phone.value) {
        data.errors.phone = 'Укажите, пожалуйста, ваш телефон';
      }
      if (context === 'main' || context === 'main-pm') {
        if (!city.value) {
          data.errors.officeCity = 'Укажите, пожалуйста, ваш город';
        }
        if (!feedback.value.office) {
          data.errors.officeName = 'Укажите, пожалуйста, офис продаж';
        }
      }
      if (phone.value.length < 10) {
        data.errors.phone = '10-значный номер, пример: 9267774433';
      }
      // if (!email.value || !isValidEmail(email.value)) {
      //   data.errors.email = 'Укажите, пожалуйста, корректный адрес';
      // }
      if (Object.values(data.errors).every((value) => value === null)) {
        return true;
      }

      return false;
    };
    // const fillFormTEST = () => {
    //   $store.commit('updateCity', '1095');
    //   $store.commit('updateFeedback', ({
    //     office: '1233697',
    //     username: 'Кириллица',
    //     phone: '9999999999',
    //     email: 'test@test.test',
    //     adding: 'Кириллица',
    //   }));
    // };
    const submitForm = () => {
      // fillFormTEST();

      if (!checkForm()) return;

      $store.dispatch('sendFeedback');
      console.log('hi');
    };

    return {
      isLoading,
      netCities,
      netOffices,
      username,
      phone,
      email,
      adding,
      feedback,
      city,

      handleInput,
      setCity,
      setOffice,
      submitForm,
      errors,
      context,
    };
  },

});
</script>

<style scoped>
.wtv-form {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  background-color: var(--color-bg);
  padding: 18px;
  flex: 1;
  min-height: 350px;
}
.wtv-form-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.wtv-form-col,
.wtv-form-col-2 {
  flex: 1 1 200px;
  min-width: 260px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}
.wtv-form-col-2 {
  flex: 2 2 400px;
}
.wtv-form-col .wtv-form-control {
  flex: 1 0 0;
}
.wtv-form-headline {
  padding: 8px;
  font-size: 18px;
}
.wtv-form-textarea {
  display: flex;
  flex: 2;
  padding-top: 22px;
  height: 120px;
}
.wtv-form-input-requirator {
  position: absolute;
  right: 9px;
  top: 9px;
  padding: 16px 10px 14px;
  cursor: pointer;
  pointer-events: none;
  transition: 0.3s;
}
.wtv-form-input-requirator:before {
  content: '\f069';
  color: var(--color-text);
  font-size: 12px;
}
.wtv-red,
.wtv-red:before {
  color: var(--color-second);
}
.wtv-form-input::placeholder {
  color: var(--color-text);
  font-weight: 600;
  opacity: 0.75;
}
.wtv-form-input:focus::placeholder {
  color: var(--color-alt);
}
</style>
